export const styles = {
  wrapper: 'tw-inline-block',
  tooltip:
    'tw-z-[9999] tw-bg-white tw-border tw-border-solid tw-border-neutral-200 tw-rounded-lg tw-shadow-lg tw-p-3 tw-max-h-64 tw-overflow-hidden tw-flex tw-flex-col',
  header: 'tw-text-xs tw-font-medium tw-text-neutral-600 tw-mb-2 tw-flex-shrink-0',
  content: 'tw-overflow-y-auto tw-flex-1',
};
